import { render, staticRenderFns } from "./MainTabComponent.view.vue?vue&type=template&id=09b8f3de&"
import script from "./MainTabComponent.view.vue?vue&type=script&lang=js&"
export * from "./MainTabComponent.view.vue?vue&type=script&lang=js&"
import style0 from "./MainTabComponent.view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports